'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _GlyphString2 = require('./GlyphString');

var _GlyphString3 = _interopRequireDefault(_GlyphString2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineFragment = function (_GlyphString) {
  (0, _inherits3.default)(LineFragment, _GlyphString);

  function LineFragment(rect, glyphString) {
    (0, _classCallCheck3.default)(this, LineFragment);

    var _this = (0, _possibleConstructorReturn3.default)(this, _GlyphString.call(this, glyphString.string, glyphString.glyphRuns));

    _this.rect = rect;
    _this.glyphString = glyphString;
    _this.decorationLines = [];
    _this.overflowLeft = 0;
    _this.overflowRight = 0;
    _this.stringStart = null;
    _this.stringEnd = null;
    return _this;
  }

  LineFragment.prototype.copy = function copy() {
    var rect = this.rect.copy();
    var glyphString = this.glyphString.copy();

    var instance = new LineFragment(rect, glyphString);

    instance.decorationLines = this.decorationLines;
    instance.overflowLeft = this.overflowLeft;
    instance.overflowRight = this.overflowRight;
    instance.stringStart = this.stringStart;
    instance.stringEnd = this.stringEnd;

    return instance;
  };

  return LineFragment;
}(_GlyphString3.default);

exports.default = LineFragment;